import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSJSON: any;
  AWSDate: any;
  AWSDateTime: any;
};

export enum CourseEnrollmentStatus {
  DROPPED = 'DROPPED',
  ENROLLED = 'ENROLLED',
  WITHDRAWN = 'WITHDRAWN'
}

export type GetReleasedTransactionsRequest = {
  academicPartnerId: Scalars['ID'];
  batchIds?: InputMaybe<Array<Scalars['ID']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  termCodes: Array<Scalars['String']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export enum ErrorLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  WARNING = 'WARNING'
}

export enum RecordType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export enum Eligibility_EligibilityType {
  ACADEMIC_PERFORMANCE = 'ACADEMIC_PERFORMANCE',
  COMPREHENSIVE = 'COMPREHENSIVE',
  CORPORATE = 'CORPORATE',
  ENROLLMENT = 'ENROLLMENT'
}

export enum Eligibility_RuleLevel {
  COVERAGE_PACKAGE = 'COVERAGE_PACKAGE',
  EMPLOYER = 'EMPLOYER'
}

export enum Eligibility_ComponentType {
  COMPONENT = 'component',
  DATASTORE = 'datastore',
  SERVICE = 'service',
  SYSTEM = 'system'
}

export enum Eligibility_HealthStatus {
  FAIL = 'fail',
  PASS = 'pass',
  WARN = 'warn'
}

export enum Eligibility_FetchPolicy {
  DB_ONLY = 'DB_ONLY',
  DEFAULT = 'DEFAULT',
  NO_DB = 'NO_DB'
}

export type Eligibility_WhereInput = {
  asOf?: InputMaybe<Scalars['AWSDate']>;
  identity: Eligibility_IdentityInput;
  partners?: InputMaybe<Array<Eligibility_PartnerInput>>;
};

export type Eligibility_IdentityInput = {
  employeeId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type Eligibility_PartnerInput = {
  partnerId: Scalars['String'];
  partnerType: Eligibility_PartnerType;
};

export enum Eligibility_PartnerType {
  ACADEMIC = 'ACADEMIC',
  EMPLOYER = 'EMPLOYER'
}

export type EmploymentService_GetEmployeeInput = {
  asOf?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  employerId: Scalars['ID'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type EmploymentService_GetEmployeesInput = {
  asOf?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['String']>;
  employerId: Scalars['ID'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum EmploymentService_EmployeeTerminationStatus {
  EMPLOYER_NOT_SUPPORTED = 'EMPLOYER_NOT_SUPPORTED',
  NOT_TERMINATED = 'NOT_TERMINATED',
  TERMINATED = 'TERMINATED'
}

export type EmploymentService_SearchDependentsInput = {
  dateOfBirth?: InputMaybe<Scalars['AWSDate']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  relatedEmployeeId?: InputMaybe<Scalars['String']>;
};

export type EmploymentService_SearchEmployeesInput = {
  dateOfBirth?: InputMaybe<Scalars['AWSDate']>;
  email?: InputMaybe<Scalars['String']>;
  employeeAlternateId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type EmploymentService_SearchEmployersInput = {
  eciSupported?: InputMaybe<Scalars['Boolean']>;
  guildPartnershipStatus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};

export enum FhsMxCrud_AvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  MULTIPLE_ENROLLMENTS = 'MULTIPLE_ENROLLMENTS',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type Funding_BulkGetSpendByProductInput = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
  keys: Array<Funding_BulkGetSpendByProductKey>;
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_BulkGetSpendByProductKey = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  memberId: Scalars['ID'];
};

export enum Funding_Product {
  EXTERNAL = 'EXTERNAL',
  PROFESSIONAL_EXPENSES = 'PROFESSIONAL_EXPENSES',
  SPONSORSHIP = 'SPONSORSHIP',
  STUDENT_LOAN_BENEFIT = 'STUDENT_LOAN_BENEFIT',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT'
}

export type Funding_BulkGetStudentSpendByAchievementType = {
  audience?: InputMaybe<Scalars['String']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  keys: Array<Funding_BulkGetStudentSpendAchievementTypeRequestKey>;
  origin?: InputMaybe<Scalars['String']>;
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_BulkGetStudentSpendAchievementTypeRequestKey = {
  achievementType: Scalars['String'];
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
  guildUuid: Scalars['ID'];
};

export type Funding_BulkGetStudentSpendByProgramId = {
  audience?: InputMaybe<Scalars['String']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  keys: Array<Funding_BulkGetStudentSpendProgramIdRequestKey>;
  origin?: InputMaybe<Scalars['String']>;
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_BulkGetStudentSpendProgramIdRequestKey = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  guildUuid: Scalars['ID'];
  programUuid: Scalars['ID'];
};

export type Funding_GetAdjustmentFileUploadUrlInput = {
  fileName: Scalars['String'];
};

export type Funding_GetBenefitPeriodsByEmployerIdInput = {
  asOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
};

export enum Funding_Sequence {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  NEXT = 'NEXT',
  OLDER = 'OLDER',
  PREVIOUS = 'PREVIOUS'
}

export type Funding_GetCustomBenefitConfiguration = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  asOf: Scalars['AWSDate'];
  category: Funding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID'];
  memberId: Scalars['ID'];
};

export enum Funding_CustomBenefitConfigurationCategory {
  FALLBACK = 'fallback',
  MODIFY = 'modify',
  OVERRIDE = 'override'
}

export type Funding_GetLearnerSpendReportUrlInput = {
  fileName: Scalars['String'];
};

export type Funding_GetSpendByProductInput = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
  memberId: Scalars['ID'];
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_GetStudentSpend = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  achievementType?: InputMaybe<Scalars['String']>;
  audience?: InputMaybe<Scalars['String']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
  guildUuid: Scalars['ID'];
  origin?: InputMaybe<Scalars['String']>;
  partnerStudentId?: InputMaybe<Scalars['String']>;
  product: Funding_Product;
  programUuid?: InputMaybe<Scalars['ID']>;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_GetTaxPeriodsInput = {
  asOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
};

export type Funding_ListAdjustments = {
  benefitLockedOn?: InputMaybe<Funding_DateRange>;
  committedAt?: InputMaybe<Funding_DateRange>;
  createdAt?: InputMaybe<Funding_DateTimeRange>;
  employerId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['String']>;
  expenseTypeId?: InputMaybe<Scalars['ID']>;
  guildUuid?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  payor?: InputMaybe<Funding_Payor>;
  product?: InputMaybe<Funding_Product>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Funding_DateRange = {
  endDate?: InputMaybe<Scalars['AWSDate']>;
  startDate?: InputMaybe<Scalars['AWSDate']>;
};

export type Funding_DateTimeRange = {
  endDate?: InputMaybe<Scalars['AWSDateTime']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']>;
};

export enum Funding_Payor {
  EMPLOYER = 'employer',
  GUILD = 'guild'
}

export type Funding_ListJobsInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nameLike?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Funding_JobStatus>>>;
  types?: InputMaybe<Array<InputMaybe<Funding_JobType>>>;
};

export enum Funding_JobStatus {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  PENDING = 'PENDING'
}

export enum Funding_JobType {
  CREATE_ADJUSTMENTS_FROM_FILE = 'CREATE_ADJUSTMENTS_FROM_FILE',
  CREATE_ADJUSTMENTS_FROM_FILE_DRY_RUN = 'CREATE_ADJUSTMENTS_FROM_FILE_DRY_RUN'
}

export enum Funding_ListJobsError {
  INVALID_INPUT = 'INVALID_INPUT',
  UNKNOWN = 'UNKNOWN'
}

export type Funding_ListLearnerSpendReportsInput = {
  employerId: Scalars['ID'];
  year: Scalars['String'];
};

export type Funding_ResolveJobInput = {
  id: Scalars['ID'];
};

export enum Funding_ResolveJobError {
  AS = 'as',
  CHANGE = 'change',
  ERRORS = 'errors',
  GROW = 'grow',
  THIS = 'This',
  UNKNOWN = 'UNKNOWN',
  WILL = 'will'
}

export enum PaymentModalityType {
  DIRECTPAY = 'DirectPay'
}

export enum Changeset_State {
  APPROVED = 'approved',
  ARCHIVED = 'archived',
  DRAFT = 'draft',
  LIVE = 'live'
}

export type ModelM_LeadsFilterInput = {
  academicPartnerId: Scalars['ID'];
  guildUuidFilter?: InputMaybe<Array<Scalars['String']>>;
  leadStateFilter?: InputMaybe<Array<Scalars['String']>>;
  partnerProgramCodeFilter?: InputMaybe<Array<Scalars['String']>>;
  partnerTermCodeFilter?: InputMaybe<Array<Scalars['String']>>;
};

export type ModelM_PaginationInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
};

export type ModelM_ListLeadsByStudentInput = {
  academicPartnerId: Scalars['ID'];
  guildUuid: Scalars['String'];
};

export enum ModelM_FileMetricsModuleName {
  ADMISSION = 'admission',
  COURSE_COMPLETION = 'course_completion',
  COURSE_ENROLLMENT = 'course_enrollment',
  COURSE_RECONCILIATION = 'course_reconciliation',
  LEARNING_PARTNER_RECONCILIATION = 'learning_partner_reconciliation',
  LEARNING_PARTNER_TUITION = 'learning_partner_tuition',
  SPONSORSHIP_ADJUSTMENTS = 'sponsorship_adjustments',
  SPONSORSHIP_TUITION = 'sponsorship_tuition',
  STUDENT_PROGRESS = 'student_progress',
  STUDENT_STATUS = 'student_status',
  TUITION = 'tuition'
}

export enum ModelM_FileUploadCategory {
  DUPLICATE = 'DUPLICATE',
  FORMATTING = 'FORMATTING',
  ISSUE = 'ISSUE',
  MISSING = 'MISSING',
  TERM = 'TERM',
  WARNING = 'WARNING'
}

export enum ModelM_FileUploadCode {
  ADMISSION002 = 'ADMISSION002',
  ADMISSION003 = 'ADMISSION003',
  DUPLICATE001 = 'DUPLICATE001',
  DUPLICATE002 = 'DUPLICATE002',
  FORMAT001 = 'FORMAT001',
  FORMAT002 = 'FORMAT002',
  FORMAT003 = 'FORMAT003',
  FORMAT004 = 'FORMAT004',
  GEN001 = 'GEN001',
  GEN002 = 'GEN002',
  GEN003 = 'GEN003',
  INVALIDCHAR001 = 'INVALIDCHAR001',
  INVALIDPROGRAMID001 = 'INVALIDPROGRAMID001',
  MISSING001 = 'MISSING001',
  MISSING002 = 'MISSING002',
  MISSING003 = 'MISSING003',
  MISSING004 = 'MISSING004',
  MISSING005 = 'MISSING005',
  MISSING006 = 'MISSING006',
  TERM001 = 'TERM001',
  TERM002 = 'TERM002',
  TERM003 = 'TERM003',
  TERM004 = 'TERM004',
  TERM005 = 'TERM005',
  UNKNOWNENTITY001 = 'UNKNOWNENTITY001',
  UNKNOWNENTITY002 = 'UNKNOWNENTITY002',
  UNKNOWNENTITY003 = 'UNKNOWNENTITY003',
  UNKNOWNENTITY004 = 'UNKNOWNENTITY004',
  UNKNOWNENTITY006 = 'UNKNOWNENTITY006',
  UNKNOWNENTITY007 = 'UNKNOWNENTITY007',
  UNKNOWNENTITY008 = 'UNKNOWNENTITY008',
  UNKNOWNENTITY009 = 'UNKNOWNENTITY009',
  UNKNOWNENTITY010 = 'UNKNOWNENTITY010',
  UNKNOWNENTITY011 = 'UNKNOWNENTITY011',
  UNKNOWNENTITY012 = 'UNKNOWNENTITY012',
  UNKNOWNENTITY013 = 'UNKNOWNENTITY013',
  UNKNOWNENTITY014 = 'UNKNOWNENTITY014'
}

export enum ModelM_FileUploadStatus {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED'
}

export type ModelM_StudentFilterInput = {
  academicPeriodIdentifierFilter?: InputMaybe<Array<Scalars['String']>>;
  admissionDecisionFilter?: InputMaybe<Array<Scalars['String']>>;
  eligibilityFilter?: InputMaybe<Array<ModelM_EligibilityFilter>>;
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
  expectedStartTermFilter?: InputMaybe<Array<Scalars['ID']>>;
  financialStatusFilter?: InputMaybe<Array<ModelM_FinancialStatus>>;
  guildUuidFilter?: InputMaybe<Array<Scalars['String']>>;
  profileStatusFilter?: InputMaybe<Array<ModelM_StudentProfileStatus>>;
  programLevelFilter?: InputMaybe<Array<ModelM_ProgramLevel>>;
};

export enum ModelM_EligibilityFilter {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE'
}

export enum ModelM_FinancialStatus {
  BENEFIT_UNASSIGNED = 'BENEFIT_UNASSIGNED',
  CAPPED = 'CAPPED',
  FULL_PAY = 'FULL_PAY',
  NO_FUNDING = 'NO_FUNDING'
}

export enum ModelM_StudentProfileStatus {
  COMPLETE = 'COMPLETE',
  CONFIRMED = 'CONFIRMED',
  FLAGGED = 'FLAGGED',
  INCOMPLETE = 'INCOMPLETE'
}

export enum ModelM_ProgramLevel {
  GRADUATE = 'GRADUATE',
  GRADUATE_CERTIFICATE = 'GRADUATE_CERTIFICATE',
  OTHER = 'OTHER',
  UNDERGRADUATE = 'UNDERGRADUATE'
}

export type ModelM_OrderBySortInput = {
  name: Scalars['String'];
  sort?: InputMaybe<ModelM_SortInput>;
};

export enum ModelM_SortInput {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelM_GraduatedStudentFilterInput = {
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
  programFilter?: InputMaybe<Array<Scalars['String']>>;
  termFilter?: InputMaybe<Array<Scalars['String']>>;
};

export type ModelM_LearningStudentsProgressFilterInput = {
  academicPeriodIdentifierFilter?: InputMaybe<Array<Scalars['String']>>;
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
};

export enum ModelM_ProcessingStatus {
  CLEAN = 'CLEAN',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  INFECTED = 'INFECTED',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED',
  SCANNING = 'SCANNING',
  SKIP = 'SKIP',
  UNKNOWN = 'UNKNOWN'
}

export enum SponsorshipRecordType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export enum ModelM_TuitionRecordType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export type ModelM_LearningStudentsStatusFilterInput = {
  academicPeriodIdentifierFilter?: InputMaybe<Array<Scalars['String']>>;
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
};

export type ModelM_LearningTuitionFilterInput = {
  academicPeriodIdentifierFilter?: InputMaybe<Array<Scalars['String']>>;
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
  invoiceIdentifierFilter?: InputMaybe<Array<Scalars['String']>>;
  reconciliationFilter?: InputMaybe<Scalars['Boolean']>;
};

export enum ModelM_LearningTuitionRecordType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export type ModelM_ProgramsFilterInput = {
  activeFilter?: InputMaybe<Array<Scalars['String']>>;
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
  programLevelFilter?: InputMaybe<Array<Scalars['String']>>;
};

export type ModelM_StudentCourseFilterInput = {
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
};

export type ModelM_StudentSponsorshipFilterInput = {
  invoiceIdentifierFilter?: InputMaybe<Array<Scalars['String']>>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lockedFilter?: InputMaybe<Scalars['Boolean']>;
  reconciliationFilter?: InputMaybe<Scalars['Boolean']>;
  recordType?: InputMaybe<SponsorshipRecordType>;
  termCodeFilter?: InputMaybe<Array<Scalars['String']>>;
};

export type ModelM_StudentTuitionsFilterInput = {
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
  reconciliationFilter?: InputMaybe<Scalars['Boolean']>;
};

export type ModelM_UsersFilterInput = {
  accountStatusFilter?: InputMaybe<Array<ModelM_AccountStatusFilter>>;
};

export enum ModelM_AccountStatusFilter {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum Changeset_ResourceType {
  EMPLOYER_INSTITUTIONS = 'employer_institutions',
  PLAN = 'plan',
  POPULATION = 'population',
  PROGRAM = 'program'
}

export enum Plan_UserPlanReasonCode {
  ELIGIBILITY_UNKNOWN = 'ELIGIBILITY_UNKNOWN',
  INELIGIBLE = 'INELIGIBLE',
  NO_EMPLOYEE_DATA = 'NO_EMPLOYEE_DATA',
  NO_POPULATION_MATCH = 'NO_POPULATION_MATCH',
  POPULATION_MATCH = 'POPULATION_MATCH'
}

export enum PostProfileCompletionRouteType {
  ENROLL = 'enroll',
  GO_TO_HOME = 'go_to_home',
  PROGRAM_FIT = 'program_fit',
  SPONSORSHIP = 'sponsorship',
  TUITION_ASSISTANCE_ENROLLED = 'tuition_assistance_enrolled',
  TUITION_REIMBURSEMENT = 'tuition_reimbursement'
}

export enum ProgramReportedDataStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable'
}

export enum ProgramCodeService_ProgramCodeSource {
  ACADEMICPARTNER = 'academicPartner',
  GUILD = 'guild'
}

export type ProgramCodeService_ProgramMappingInput = {
  academicPartnerId: Scalars['String'];
  confirmedNoMapping?: InputMaybe<Scalars['Boolean']>;
  guildProgramUuid?: InputMaybe<Scalars['String']>;
  partnerProgramCode?: InputMaybe<Scalars['String']>;
  partnerProgramCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type TmpSoarEmails_EmployerInfo = {
  employer: Scalars['String'];
  employerNickname: Scalars['String'];
  employerUuid: Scalars['ID'];
};

export type TmpSoarEmails_ReferrerInfo = {
  referrerEmail: Scalars['String'];
  referrerName: Scalars['String'];
};

export type Ups_SearchUserInput = {
  attribute: Attribute;
  paginationInput?: InputMaybe<Ups_PaginationInput>;
  searchTerm: Scalars['String'];
};

export enum Attribute {
  AUTH0ID = 'auth0Id',
  EMAIL = 'email',
  NAME = 'name',
  PHONE = 'phone',
  STUDENTID = 'studentId',
  UUID = 'uuid'
}

export type Ups_PaginationInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
};

export enum DataExchangeType {
  ADMISSIONS = 'ADMISSIONS',
  ENROLLMENTS = 'ENROLLMENTS',
  FINANCIALS = 'FINANCIALS'
}

export enum GuildIdType {
  EXTERNAL_ID = 'EXTERNAL_ID',
  GUILD_UUID = 'GUILD_UUID'
}

export type UpdateTransactionsRequest = {
  academicPartnerId: Scalars['ID'];
  updatedBy: Scalars['String'];
  updateParameters: Array<UpdateTransactionPayload>;
  updateType: UpdateTransactionType;
};

export type UpdateTransactionPayload = {
  newInternalStudentId?: InputMaybe<Scalars['ID']>;
  transactionId: Scalars['ID'];
};

export enum UpdateTransactionType {
  DEACTIVATE = 'DEACTIVATE',
  IDENTITY = 'IDENTITY'
}

export type Plan_ChangesetDetails = {
  effective: Scalars['AWSDateTime'];
  guildApprover: Scalars['String'];
  reason: Scalars['String'];
};

export type EmploymentService_MutateEmployerAudit = {
  requester: Scalars['String'];
};

export type EmploymentService_CreateEmployerInput = {
  eciSupported?: InputMaybe<Scalars['Boolean']>;
  guildPartnershipStatus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};

export type EmploymentService_UpdateEmployerInput = {
  eciSupported?: InputMaybe<Scalars['Boolean']>;
  guildPartnershipStatus?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};

export type Funding_BulkCreateCustomBenefitConfigurationInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  assignedBy: Scalars['ID'];
  category: Funding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  fundingLimits: Array<InputMaybe<Funding_CustomFundingLimitInput>>;
  grossUpEligibility?: InputMaybe<Scalars['Boolean']>;
  guildUuids: Array<Scalars['ID']>;
  metadata: Scalars['AWSJSON'];
  reason: Scalars['String'];
  startsOn: Scalars['AWSDate'];
  taxSection?: InputMaybe<Scalars['String']>;
};

export type Funding_CustomFundingLimitInput = {
  expenseTypes: Array<Scalars['String']>;
  fundingLimitCents?: InputMaybe<Scalars['Int']>;
  includedInTuition?: InputMaybe<Scalars['Boolean']>;
};

export type Funding_BulkUpdateTaxPeriodsInput = {
  employerId: Scalars['ID'];
  taxPeriods?: InputMaybe<Array<InputMaybe<Funding_UpdateTaxPeriods>>>;
};

export type Funding_UpdateTaxPeriods = {
  endsAfter: Scalars['AWSDate'];
  id: Scalars['ID'];
  startsOn: Scalars['AWSDate'];
};

export type Funding_CreateAdjustmentsFromFileInput = {
  asyncRequestId?: InputMaybe<Scalars['ID']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  employerId?: InputMaybe<Scalars['ID']>;
  expenseTypeId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  originProduct?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Funding_Product>;
  reason?: InputMaybe<Scalars['String']>;
  supportingDocuments?: InputMaybe<Scalars['String']>;
};

export type Funding_CreateBenefitPeriodInput = {
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  startsOn: Scalars['AWSDate'];
};

export type Funding_CreateCustomBenefitConfigurationInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  assignedBy: Scalars['ID'];
  category: Funding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  fundingLimits: Array<InputMaybe<Funding_CustomFundingLimitInput>>;
  grossUpEligibility?: InputMaybe<Scalars['Boolean']>;
  guildUuid: Scalars['ID'];
  metadata: Scalars['AWSJSON'];
  reason: Scalars['String'];
  startsOn: Scalars['AWSDate'];
  taxSection?: InputMaybe<Scalars['String']>;
};

export type Funding_CreateSpend = {
  academicInstitutionName?: InputMaybe<Scalars['String']>;
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  allowCapOverage?: InputMaybe<Scalars['Boolean']>;
  amountCents: Scalars['Int'];
  benefitLockedOn: Scalars['String'];
  capAsOf: Scalars['String'];
  committedAt: Scalars['String'];
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  expenseTypeId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  isCrossYear?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  memberAttestedTaxSection132?: InputMaybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
  metadata?: InputMaybe<Scalars['AWSJSON']>;
  origin: Scalars['String'];
  originApplicationId?: InputMaybe<Scalars['String']>;
  originProduct?: InputMaybe<Scalars['String']>;
  originRecordId: Scalars['String'];
  originRecordName: Scalars['String'];
  payor?: InputMaybe<Funding_Payor>;
  product: Funding_Product;
  productContext?: InputMaybe<ProductContext>;
};

export type ProductContext = {
  sponsorship?: InputMaybe<SponsorshipProductContext>;
  tuitionAssistance?: InputMaybe<TuitionAssistanceProductContext>;
  tuitionReimbursement?: InputMaybe<TuitionReimbursementProductContext>;
};

export type SponsorshipProductContext = {
  achievementType: Scalars['String'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
};

export type TuitionAssistanceProductContext = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
};

export type TuitionReimbursementProductContext = {
  achievementType: Scalars['String'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
};

export type Funding_CreateTaxPeriodInput = {
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  startsOn: Scalars['AWSDate'];
};

export type Funding_GenerateLearnerSpendReport = {
  additionalColumns?: InputMaybe<Funding_AdditionalColumns>;
  bypassCrossYearReversals?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  filter?: InputMaybe<Funding_ReportFilter>;
  filterByPlanFundingPeriods?: InputMaybe<Scalars['Boolean']>;
  includeGuildUuid?: InputMaybe<Scalars['Boolean']>;
  inNetworkTR?: InputMaybe<Scalars['Boolean']>;
  productFilters?: InputMaybe<Funding_ProductFilters>;
  taxEligibleOnCutoffDate?: InputMaybe<Scalars['AWSDate']>;
  type: Funding_LearnerSpendReportType;
};

export type Funding_AdditionalColumns = {
  employee?: InputMaybe<Array<Scalars['String']>>;
};

export type Funding_ReportFilter = {
  benefitLockedOn?: InputMaybe<Funding_DateRange>;
  committedAt?: InputMaybe<Funding_DateRange>;
  taxEligibleOn?: InputMaybe<Funding_DateRange>;
};

export type Funding_ProductFilters = {
  balanceTransfer?: InputMaybe<Funding_ReportFilter>;
  sponsorship?: InputMaybe<Funding_ReportFilter>;
  studentLoanReimbursement?: InputMaybe<Funding_ReportFilter>;
  tuitionAssistance?: InputMaybe<Funding_ReportFilter>;
  tuitionReimbursement?: InputMaybe<Funding_ReportFilter>;
};

export enum Funding_LearnerSpendReportType {
  EMPLOYEE = 'EMPLOYEE',
  FAMILY_MEMBER = 'FAMILY_MEMBER',
  NEGATIVE_CROSS_YEAR = 'NEGATIVE_CROSS_YEAR'
}

export type Funding_UpdateCustomBenefitConfiguration = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  assignedBy: Scalars['ID'];
  category?: InputMaybe<Scalars['String']>;
  customBenefitConfigurationId: Scalars['ID'];
  employerId?: InputMaybe<Scalars['ID']>;
  endsAfter?: InputMaybe<Scalars['AWSDate']>;
  fundingLimits?: InputMaybe<Array<InputMaybe<Funding_CustomFundingLimitInput>>>;
  grossUpEligibility?: InputMaybe<Scalars['Boolean']>;
  guildUuid?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Scalars['AWSJSON']>;
  reason?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['AWSDate']>;
  taxSection?: InputMaybe<Scalars['String']>;
};

export type ModelM_StudentSponsorshipInput = {
  guildExternalId: Scalars['String'];
  invoiceIdentifier: Scalars['String'];
  partnerStudentId: Scalars['String'];
  qualifiedFees: Scalars['Float'];
  qualifiedGrantsAndScholarships: Scalars['Float'];
  recordType?: InputMaybe<Scalars['String']>;
  requestedEmployerPaymentAmount: Scalars['Float'];
  sponsorshipLetterId: Scalars['String'];
  termCode: Scalars['String'];
  totalGrossTuition: Scalars['Float'];
  totalNetTuition: Scalars['Float'];
};

export type ModelM_TermInput = {
  academicPartnerId?: InputMaybe<Scalars['String']>;
  addDropDate?: InputMaybe<Scalars['String']>;
  admissionEndDate?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  eligibilityDownloadDate?: InputMaybe<Scalars['String']>;
  eligibilityLockDate?: InputMaybe<Scalars['String']>;
  eligibilityLockedDate?: InputMaybe<Scalars['String']>;
  enrollmentUploadDate?: InputMaybe<Scalars['String']>;
  financialUploadDate?: InputMaybe<Scalars['String']>;
  gradesUploadDate?: InputMaybe<Scalars['String']>;
  reconciliationDate?: InputMaybe<Scalars['String']>;
  termCode: Scalars['String'];
  termEndDate: Scalars['String'];
  termId?: InputMaybe<Scalars['ID']>;
  termName: Scalars['String'];
  termStartDate: Scalars['String'];
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type ModelM_Auth0UserMetadataInput = {
  family_name?: InputMaybe<Scalars['String']>;
  given_name?: InputMaybe<Scalars['String']>;
};

export type ModelM_RoleInput = {
  roleId: Scalars['String'];
  roleName: Scalars['String'];
};

export type ModelM_DeactivateSponsorshipTuitionRecords = {
  academicPartnerId: Scalars['ID'];
  students: Array<ModelM_SponsorshipTuitionStudentRecordToUpdate>;
};

export type ModelM_SponsorshipTuitionStudentRecordToUpdate = {
  guildExternalId: Scalars['String'];
  invoiceIdentifier: Scalars['String'];
  sponsorshipLetterId: Scalars['String'];
  termCode: Scalars['String'];
};

export type ModelM_AdmissionRecordInput = {
  modelMProgramId: Scalars['String'];
  modelMTermId: Scalars['String'];
  partnerProgramCode: Scalars['String'];
  partnerStudentId?: InputMaybe<Scalars['String']>;
  partnerTermCode: Scalars['String'];
  validAdmissionStatusId: Scalars['String'];
};

export type ModelM_UpdateSponsorshipInput = {
  academicPartnerId: Scalars['ID'];
  guildExternalId: Scalars['ID'];
  invoiceIdentifier: Scalars['String'];
  sponsorshipLetterId: Scalars['ID'];
};

export type Monolith_CreateEmployerInput = {
  name: Scalars['String'];
  url_nickname: Scalars['String'];
  uuid: Scalars['String'];
};

export type Monolith_UpdateEmployerInput = {
  name?: InputMaybe<Scalars['String']>;
  url_nickname?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type FundingClassificationInput = {
  fundingClassificationType: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type Plan_PlanProgramInput = {
  catalogEligible?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['AWSDate']>;
  fundingEligible?: InputMaybe<Scalars['Boolean']>;
  fundingPackageId: Scalars['ID'];
  programId: Scalars['ID'];
  status: Scalars['String'];
  targetTermId?: InputMaybe<Scalars['String']>;
};

export type Plan_ProductAttributesInput = {
  deferredTuitionAllowed?: InputMaybe<Scalars['Boolean']>;
  fundingLimit?: InputMaybe<Scalars['Int']>;
  grossUps?: InputMaybe<Scalars['Boolean']>;
  isAdditionalFunding?: InputMaybe<Scalars['Boolean']>;
  optimizationAvailable?: InputMaybe<Scalars['Boolean']>;
  reimbursementAvailable?: InputMaybe<Scalars['Boolean']>;
  rolloversAllowed?: InputMaybe<Scalars['Boolean']>;
  taxSection?: InputMaybe<Scalars['String']>;
};

export type Population_ChangesetDetails = {
  effective: Scalars['AWSDateTime'];
  guildApprover: Scalars['String'];
  reason: Scalars['String'];
};

export type ProfileCompletion_UserInput = {
  barrier?: InputMaybe<Scalars['String']>;
  barrier_text?: InputMaybe<Scalars['String']>;
  career_goal_text?: InputMaybe<Scalars['String']>;
  community_support_level?: InputMaybe<Scalars['String']>;
  current_learning_program?: InputMaybe<Scalars['String']>;
  current_learning_program_text?: InputMaybe<Scalars['String']>;
  current_learning_program_type?: InputMaybe<Scalars['String']>;
  current_learning_provider?: InputMaybe<Scalars['String']>;
  current_learning_provider_text?: InputMaybe<Scalars['String']>;
  current_learning_provider_type?: InputMaybe<Scalars['String']>;
  currently_enrolled?: InputMaybe<Scalars['Boolean']>;
  debt_amount?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enrollment_info_hidden_at?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  foreign_education?: InputMaybe<Scalars['Boolean']>;
  highest_parent_education_level?: InputMaybe<Scalars['String']>;
  how_can_we_help_you?: InputMaybe<Scalars['String']>;
  how_can_we_help_you_text?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  pathway_confidence_level?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  post_profile_completion_route?: InputMaybe<PostProfileCompletionRouteType>;
  post_profile_completion_route_rule?: InputMaybe<Scalars['String']>;
  prior_education_experience?: InputMaybe<Scalars['String']>;
  prior_education_experience_text?: InputMaybe<Scalars['String']>;
  sponsorship_school?: InputMaybe<Scalars['String']>;
  sponsorship_school_text?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
  timing_text?: InputMaybe<Scalars['String']>;
  transition_student?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type ProgramCodeService_ProgramCodeInput = {
  academicPartnerId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  metadata?: InputMaybe<Scalars['AWSJSON']>;
  programCodeSource: ProgramCodeService_ProgramCodeSource;
  programName?: InputMaybe<Scalars['String']>;
};

export type Ups_UpdateUserInput = {
  firstName: Scalars['String'];
  guildUuid: Scalars['ID'];
  lastName: Scalars['String'];
};

export type Ups_UpsertContactStrategyInput = {
  contactType: Scalars['Int'];
  guildUuid: Scalars['ID'];
  primary: Scalars['Boolean'];
  value: Scalars['String'];
};

export enum FileType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export enum ModelM_PortalConfigType {
  FILES = 'FILES',
  FULL = 'FULL',
  FULL_LEARNING_HYBRID = 'FULL_LEARNING_HYBRID',
  LEARNING = 'LEARNING',
  LEARNING_PLUS = 'LEARNING_PLUS',
  MAPPING = 'MAPPING',
  SPONSORSHIP = 'SPONSORSHIP'
}

export enum ModelTypeConfiguration {
  MODEL_L = 'MODEL_L',
  MODEL_M = 'MODEL_M'
}

export type OrderBySortInput = {
  name: Scalars['String'];
  sort?: InputMaybe<SortInput>;
};

export enum SortInput {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StudentTuitionsFilterInput = {
  employerFilter?: InputMaybe<Array<Scalars['String']>>;
  reconciliationFilter?: InputMaybe<Scalars['Boolean']>;
};

export type Ups_UpsertEpPortalUserInput = {
  active: Scalars['Boolean'];
  email: Scalars['String'];
  employee_id: Scalars['ID'];
  employer_uuid: Scalars['ID'];
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  roles: Array<InputMaybe<Scalars['String']>>;
};

export enum ValidationCategory {
  DUPLICATE = 'DUPLICATE',
  FORMATTING = 'FORMATTING',
  ISSUE = 'ISSUE',
  MISSING = 'MISSING',
  TERM = 'TERM',
  WARNING = 'WARNING'
}

export enum ValidationCode {
  ADMISSION002 = 'ADMISSION002',
  DUPLICATE001 = 'DUPLICATE001',
  DUPLICATE002 = 'DUPLICATE002',
  DUPLICATE003 = 'DUPLICATE003',
  FIN_DUPLICATE001 = 'FIN_DUPLICATE001',
  FIN_FORMAT001 = 'FIN_FORMAT001',
  FIN_FORMAT002 = 'FIN_FORMAT002',
  FIN_FORMAT003 = 'FIN_FORMAT003',
  FIN_FORMAT004 = 'FIN_FORMAT004',
  FIN_GEN001 = 'FIN_GEN001',
  FIN_GEN002 = 'FIN_GEN002',
  FIN_INVALIDCHAR001 = 'FIN_INVALIDCHAR001',
  FIN_INVALIDCHAR003 = 'FIN_INVALIDCHAR003',
  FIN_MISSING002 = 'FIN_MISSING002',
  FIN_TERM001 = 'FIN_TERM001',
  FIN_TERM006 = 'FIN_TERM006',
  FIN_TUITION001 = 'FIN_TUITION001',
  FIN_TUITION002 = 'FIN_TUITION002',
  FIN_TXENROLL001 = 'FIN_TXENROLL001',
  FIN_TXENROLL002 = 'FIN_TXENROLL002',
  FIN_UNKNOWNENTITY007 = 'FIN_UNKNOWNENTITY007',
  FIN_UNKNOWNENTITY010 = 'FIN_UNKNOWNENTITY010',
  FORMAT001 = 'FORMAT001',
  FORMAT002 = 'FORMAT002',
  FORMAT003 = 'FORMAT003',
  FORMAT004 = 'FORMAT004',
  GEN001 = 'GEN001',
  GEN002 = 'GEN002',
  GEN003 = 'GEN003',
  INVALIDCHAR001 = 'INVALIDCHAR001',
  INVALIDCHAR002 = 'INVALIDCHAR002',
  INVALIDCHAR003 = 'INVALIDCHAR003',
  INVALIDCHAR004 = 'INVALIDCHAR004',
  MISSING001 = 'MISSING001',
  MISSING002 = 'MISSING002',
  MISSING003 = 'MISSING003',
  TERM001 = 'TERM001',
  TERM002 = 'TERM002',
  TERM003 = 'TERM003',
  TERM004 = 'TERM004',
  TERM005 = 'TERM005',
  TERM006 = 'TERM006',
  TUITION001 = 'TUITION001',
  TUITION002 = 'TUITION002',
  UNKNOWNENTITY003 = 'UNKNOWNENTITY003',
  UNKNOWNENTITY006 = 'UNKNOWNENTITY006',
  UNKNOWNENTITY007 = 'UNKNOWNENTITY007',
  UNKNOWNENTITY008 = 'UNKNOWNENTITY008',
  UNKNOWNENTITY009 = 'UNKNOWNENTITY009',
  UNKNOWNENTITY010 = 'UNKNOWNENTITY010',
  UNKNOWNENTITY012 = 'UNKNOWNENTITY012',
  UNKNOWNENTITY013 = 'UNKNOWNENTITY013'
}

export type GetDeferredTargetTermQueryVariables = Exact<{
  termId: Scalars['String'];
}>;


export type GetDeferredTargetTermQuery = { AcademicService_getTermById?: { startDate: string, termId: string } | null };


export const GetDeferredTargetTermDocument = gql`
    query getDeferredTargetTerm($termId: String!) {
  AcademicService_getTermById(termId: $termId) {
    startDate
    termId
  }
}
    `;

/**
 * __useGetDeferredTargetTermQuery__
 *
 * To run a query within a React component, call `useGetDeferredTargetTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeferredTargetTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeferredTargetTermQuery({
 *   variables: {
 *      termId: // value for 'termId'
 *   },
 * });
 */
export function useGetDeferredTargetTermQuery(baseOptions: Apollo.QueryHookOptions<GetDeferredTargetTermQuery, GetDeferredTargetTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeferredTargetTermQuery, GetDeferredTargetTermQueryVariables>(GetDeferredTargetTermDocument, options);
      }
export function useGetDeferredTargetTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeferredTargetTermQuery, GetDeferredTargetTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeferredTargetTermQuery, GetDeferredTargetTermQueryVariables>(GetDeferredTargetTermDocument, options);
        }
export type GetDeferredTargetTermQueryHookResult = ReturnType<typeof useGetDeferredTargetTermQuery>;
export type GetDeferredTargetTermLazyQueryHookResult = ReturnType<typeof useGetDeferredTargetTermLazyQuery>;
export type GetDeferredTargetTermQueryResult = Apollo.QueryResult<GetDeferredTargetTermQuery, GetDeferredTargetTermQueryVariables>;